//FIXME speaker nur einmal
/**
 * User: herbert
 * Date: 03.11.15
 * Time: 15:20
 */

/* eslint smells/no-complex-switch-case: 0 */

export const fotoUrl = './';
export const zoomPath = 'img/stele/zoom/';


export const PART_MODUL_KAMERA_MAX_SUPERHEIGHT = 1455; // mm; sum of .height of cfgs above

// Array mit verfügbaren Teilen: jeder Eintrag entspricht einem Eintrag in der ConfigBar von oben nach unten
// Jeder Eintrag hat unter Variants einen Array mit Ausprägungen, die durch die Bezeichnung description und der
// Parameterliste params für new StelePart

// IMPORTANT: keep this list in sync with the contents of ALL_PARTS at the end of the file

export const PART_MODUL_WLAN_NAME = 'wlan';
export const PART_MODUL_KAMERA_NAME = 'cam';
export const PART_MODUL_RGBW_NAME ='rgbw';
//export const PART_MODUL_RGBW_W_NAME ='rgbww';
export const PART_MODUL_WEGE_NAME ='wege';
export const PART_MODUL_WEGE2_NAME ='wege2';
export const PART_MODUL_AUFNAHME_250_NAME ='aufnahme250';
export const PART_MODUL_AUFNAHME_500_NAME ='aufnahme500';
export const PART_MODUL_AUFNAHME_1000_NAME ='aufnahme1000';
export const PART_MODUL_AUFNAHME_1500_NAME ='aufnahme1500';
export const PART_ELEMENT_VERT_NAME = 'vert';
export const PART_ELEMENT_TWINSPOT_NAME ='twinspot';
export const PART_ELEMENT_SPEAKER_NAME ='speaker';
export const PART_ELEMENT_FASSADE_500_NAME ='f500';
export const PART_ELEMENT_GOBO_NAME ='gobo';
//export const PART_ELEMENT_FASSADE_1000_NAME ='f1000';

// names only used by zoom, summary and datasheet
export const PART_DECKEL_NAME = 'deckel';
export const PART_BASIS_NAME = 'basis';
export const PART_BASIS_TOP_NAME = 'basis-top';
export const PART_MODUL_AUFNAHME_250_COVER_NAME = 'aufnahme250-cover';
export const PART_MODUL_AUFNAHME_500_COVER_NAME = 'aufnahme500-cover';
export const PART_MODUL_AUFNAHME_1000_COVER_NAME = 'aufnahme1000-cover';
export const PART_MODUL_AUFNAHME_1500_COVER_NAME = 'aufnahme1500-cover';

export const PART_MODUL_CHARGING_NAME = 'charging';

// names only used be summary and datasheet
export const PART_LEITUNG_NAME = 'leitung';
export const PART_KASTEN_NAME = 'kasten';


// name only used by bottom.jsx
export const PART_DOOR_NAME = 'door';

// name only used by zoom

export const PART_MODUL_BASEPLATE_NAME = 'baseplate';

export const TS_SPOT='spot';
export const TS_MEDSPOT='medspot'; // selux didn't tell me how they name it :/
export const TS_MEDIUM='middle';
//export const TS_FLOOD='wide';


export const G_45 = 'g45';
export const G_63 = 'g63';
export const G_85 = 'g85';
export const G_135 = 'g135';

export const G_W_45 = 'gw45';
export const G_W_85 = 'gw85';

export const F_25 = 'f25';
export const F_45 = 'f45';

export const F_H_SYM = 'sym';
export const F_H_LEFT = 'left';
export const F_H_RIGHT = 'right';


export const F_V_NEAR_DOWN = 'near';
export const F_V_DOWN = 'down';
export const F_V_SOFT = 'soft';
export const F_V_STRONG = 'strong';
export const F_V_PAR = 'par';

export const W_SYM = 'sym';
export const W_ASYM= 'asym';
export const W_ASYM_PEDESTRIAN= 'pedestrian';
export const W_ASYM_STREET= 'street';

export const C_BOSCH = 1;
//export const C_XXX = 2; // 'passt derzeit nicht'
export const C_AXIS = 3;
export const C_ENEO = 4;

/* eslint camelcase: 0 */
 // enspricht derzeit 2017-04 den SX-Nummernkürzel
export const C_POWER_3k7 = '0';
export const C_POWER_11k = '1';
export const C_POWER_22k = '2';
// enspricht derzeit 2017-04 den SX-Nummernkürzel
export const C_TYPE_PROF = '3';
export const C_TYPE_ADV = '2';
export const C_TYPE_BASIC = '1';


export const CHARGING_POSITION_IMGS = [
	[], // 0 not used
	[
		'1_090.svg',
		'1_180.svg',
		'1_270.svg'
	],
	[
		'2_090-180.svg',	// delta 90°
		'2_090-270.svg',	// delta 180°
		'2_180-270.svg'		// delta 90°
	],
	[
		'3_090-180-270.svg'
	]
];

// aus der Tabelle oben abegeleitet
export const CHARGING_POSITION_2D180 = 1; // index for 2 charging with a delta of 180°


/** in svg-Pixel der grundlegenden getStele-Auflösung, jetzt in @see config-sizes.js */
export const PART_SIZES = {};

// img wird von summary genutzt, diese einträge außerdem noch von summary und datasheet
/**StelePartCfg*/export const PART_DECKEL = {name: PART_DECKEL_NAME, getImg: () => 'img/stele/summary/deckel.svg', container: false, H: 17};

/**StelePartCfg*/export const PART_BASIS = {name: PART_BASIS_NAME, getImg: () => null, container: false, H: NaN}; // H wird in datasheet.jsx und eingetragen

/**StelePartCfg*/export const PART_LEITUNG = {name: PART_LEITUNG_NAME, getImg: () => /* NOT IN SUMMARY */ '', container: false, H: 0};
/**StelePartCfg*/export const PART_KASTEN = {name: PART_KASTEN_NAME, getImg: () => /* NOT IN SUMMARY */ '', container: false, H: 0};



/**StelePartCfg*/export const PART_MODUL_WLAN = {name: PART_MODUL_WLAN_NAME, getImg: () => /* TODO */ 'img/stele/summary/wlan.svg', container: false, H: 630};
/**StelePartCfg*/export const PART_MODUL_KAMERA = {name: PART_MODUL_KAMERA_NAME, getImg: () => /* TODO */ 'img/stele/summary/cam.svg', container: false, H: 630};

// /**StelePartCfg*/export const PART_MODUL_RGBW_W = {name: PART_MODUL_RGBW_W_NAME, getImg: () => 'img/stele/summary/Akzentelement-w.svg', container: false, H: 85};

/**StelePartCfg*/export const PART_MODUL_RGBW = {name: PART_MODUL_RGBW_NAME, getImg: () => 'img/stele/summary/Akzentelement.svg', container: false, H: 85};
/**StelePartCfg*/export const PART_MODUL_WEGE = {name: PART_MODUL_WEGE_NAME, getImg: ({sky, gold}) => 'img/stele/summary/wege4'+(sky?'sky':'')+(gold?'_gold':'')+'.svg', container: false, H: 748};
/**StelePartCfg*/export const PART_MODUL_WEGE2 = {name: PART_MODUL_WEGE2_NAME, getImg: ({sky, gold}) => 'img/stele/summary/wege2'+(sky?'sky':'')+(gold?'_gold':'')+'.svg', container: false, H: 588};
/**StelePartCfg*/export const PART_MODUL_AUFNAHME_250 = {name: PART_MODUL_AUFNAHME_250_NAME, /*TODO*/getImg: (part) => 'img/stele/summary/aufnahme250.svg', container: 1, H: 344};
/**StelePartCfg*/export const PART_MODUL_AUFNAHME_500 = {name: PART_MODUL_AUFNAHME_500_NAME, /*TODO*/getImg: (part) => 'img/stele/summary/aufnahme500.svg', container: 2, H: 630};
/**StelePartCfg*/export const PART_MODUL_AUFNAHME_1000 = {name: PART_MODUL_AUFNAHME_1000_NAME, /*TODO*/getImg: (part) => 'img/stele/summary/aufnahme1000.svg', container: 4, H: 1148};
/**StelePartCfg*/export const PART_MODUL_AUFNAHME_1500 = {name: PART_MODUL_AUFNAHME_1500_NAME, /*TODO*/getImg: (part) => 'img/stele/summary/aufnahme1500.svg', container: 6, H: 1665};
/**StelePartCfg*/export const PART_ELEMENT_VERT = {name: PART_ELEMENT_VERT_NAME, getImg: () => 'img/stele/summary/vert.svg', container: false};
/**StelePartCfg*/export const PART_ELEMENT_TWINSPOT = {name: PART_ELEMENT_TWINSPOT_NAME, getImg: () => 'img/stele/summary/Spotmodul.svg', container: false};
/**StelePartCfg*/export const PART_ELEMENT_SPEAKER = {name: PART_ELEMENT_SPEAKER_NAME, getImg: () => /*TODO*/'img/stele/summary/speaker.svg', container: false};
/**StelePartCfg*/export const PART_ELEMENT_GOBO = {name: PART_ELEMENT_GOBO_NAME, getImg: () => /*TODO*/'img/stele/summary/gobo.svg', container: false}; // FIXME GOB summary svg
/**StelePartCfg*/export const PART_ELEMENT_FASSADE_500 = {name: PART_ELEMENT_FASSADE_500_NAME, container: false,
	getImg: (part) => {
		switch(part.horiz) {
		case F_H_LEFT:
			return 'img/stele/summary/Fassadenmodul-links.svg';
		case F_H_RIGHT:
			return 'img/stele/summary/Fassadenmodul-rechts.svg';
		default:
			return 'img/stele/summary/Fassadenmodul.svg';
		}
	}
};


export const PART_MODUL_CHARGING = {name: PART_MODUL_CHARGING_NAME, getImg: () => 'img/stele/ladestation-pers.svg', container: false, H: 0};


// TODO: diese funktion beliefert die WEGEx.enabled und die anderen mount-Funktionierne mit Infos zur Kamera. Diese berücksichtigen das dann.
// this is a helper for elements mounted on the base or above each other
function heightOverCam(/**Array.<StelePart>*/ stele) {
	let h = 0;
	for(let i=0; i < stele.length; i++) {
		if(stele[i].name === PART_MODUL_KAMERA_NAME) {
			console.log('found cam @'+i+', '+h+'mm');
			return {idx: i, height: h};
		}
		h += stele[i].cfg.H;
	}
	console.log('no cam');
	return {idx: -1, height: 0};
}


// this is for pieces placed into a container
function mountAtPosition(/**Array.<StelePart>*/ children, /**StelePart*/ part, position, maxPosition) {
	part.position = position;
	let idx=-1;
	let p=0;
	for(let i=0; i<children.length; i++) {
		//const delta = (i > 0 && children[i].name === PART_ELEMENT_FASSADE_500_NAME && children[i].position <= p+1 &&
		// children[i-1].name === PART_ELEMENT_TWINSPOT_NAME) ? 2 : 1;
		p = Math.max(p+1, children[i].position);
		//if(children[i].name === PART_ELEMENT_FASSADE_500_NAME) {
		//	p++;
		//}
		if(p>position) {
			idx = i;
			break;
		}
	}
	if(idx<0) {
		children.push(part);
	} else {
		children.splice(idx, 0, part);
	}

	// positionierungen von der tiefsten (numerisch höchsten, im Array letzten Stelle) her korrigieren TODO aufspalten in
	// eigene Funktion damit es in changeSize benutzt werden kann
	let maxP = maxPosition;
	for(let j=children.length-1; j>=0; j--) {
		// bei f500 gilt: maxP - 1
		if(children[j].name === PART_ELEMENT_FASSADE_500_NAME || children[j].name === PART_ELEMENT_GOBO_NAME) {
			maxP--;
		}
		if (children[j].position > maxP) {
			children[j].position = maxP;
		}
		maxP--;
	}
	//for(let k=0;k<children.length;k++) {
	//	console.log(k+": "+children[k].position+". "+children[k].name+(k==idx?"*":""));
	//}
	return idx < 0 ? children.length -1 : idx;
}



PART_MODUL_CHARGING.mountNew = (/**Array.<StelePart>*/ stele, /**StelePart*/ newRGBW, centerY, parentPosistions, parentIdx, childPositions, childIdx, addTemporary, /**SteleCharging*/charging) => {
	if(charging.count === 0) {
		charging.count = 1;
		charging.positioning = 1;
		charging.power = C_POWER_3k7;
		charging.type = C_TYPE_PROF;
	}
	return null;
};

// WICHTIG: die mountNew müssen bei eingesetzten Modulen testen, ob ein Element in das konkrete Aufnahmemodul passt, weil die enabled testen, ob
// es irgendwo eins gibt, das aber auch ein anderes sein kann

PART_MODUL_KAMERA.mountNew  = (/**Array.<StelePart>*/ stele, /**StelePart*/ newPart, centerY, parentPosistions, parentIdx, childPositions, childIdx, addTemporary) => {
	const minIdx = (stele.length > 0 && (stele[0].name === PART_MODUL_WEGE_NAME || stele[0].name === PART_MODUL_WEGE2_NAME)) ?
			1 :
			0;
	let maxIdx = 0;
	let h = 0;
	while(maxIdx < stele.length) {
		h+=stele[maxIdx].cfg.H;
		if(h>PART_MODUL_KAMERA_MAX_SUPERHEIGHT)
			break;
		maxIdx++;
	}
console.log('PART_MODUL_KAMERA.mountNew', parentIdx, minIdx, maxIdx);
	if(parentIdx === null || parentIdx > maxIdx) {
		parentIdx = maxIdx;
	} else if (parentIdx < minIdx) {
		parentIdx = minIdx;
	}

	if(parentIdx === stele.length) {
		stele.push(newPart);
		return {parent: maxIdx, child: null};
	} else {
		stele.splice(parentIdx, 0, newPart);
		return {parent: parentIdx, child: null};
	}
};

PART_MODUL_WEGE.mountNew = (/**Array.<StelePart>*/ stele, /**StelePart*/ newPart, centerY, parentPosistions, parentIdx, childPositions, childIdx, addTemporary) => {
	// kein test, wir velassen uns auf enabled. deshalb ist es wichtig, dass nur der kleinere aus der Leiste hineingezogen wird, weil es Situationen gibt, wo nur der, nicht aber der 4-fache passt
	newPart.temporary = addTemporary;
	stele.unshift(newPart);
	return {parent: 0, child: null};
};
PART_MODUL_WEGE2.mountNew = PART_MODUL_WEGE.mountNew;

PART_MODUL_AUFNAHME_250.mountNew = (/**Array.<StelePart>*/ stele, /**StelePart*/ newPart, centerY, parentPosistions, parentIdx, childPositions, childIdx, addTemporary) => {
	newPart.temporary = addTemporary;
	if (parentIdx !== null) {
		const minIdx = (stele.length > 0 && (stele[0].name === PART_MODUL_WEGE_NAME || stele[0].name === PART_MODUL_WEGE2_NAME)) ?
			1 :
			0;
		if (parentIdx < minIdx) {
			parentIdx = minIdx;
		}
		const oC = heightOverCam(stele);
		if (parentIdx <= oC.idx && oC.height + newPart.cfg.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT) {
			parentIdx = oC.idx + 1;
		}
	}

	if (parentIdx === null || parentIdx === stele.length) {
		stele.push(newPart);
		return {parent: stele.length - 1, child: null};
	} else {
		stele.splice(parentIdx, 0, newPart);
		return {parent: parentIdx, child: null};
	}
};

PART_MODUL_RGBW.mountNew = PART_MODUL_AUFNAHME_250.mountNew;
PART_MODUL_WLAN.mountNew = PART_MODUL_AUFNAHME_250.mountNew;

PART_MODUL_AUFNAHME_500.mountNew = PART_MODUL_AUFNAHME_250.mountNew;
PART_MODUL_AUFNAHME_1000.mountNew = PART_MODUL_AUFNAHME_250.mountNew;
PART_MODUL_AUFNAHME_1500.mountNew = PART_MODUL_AUFNAHME_250.mountNew;

/**
 *
 * @param{Array.<StelePart>} stele Array of SteleParts to whicht newElem will be mounted
 * @param{StelePart} newElem new element to mount to stele
 * @param{Number} centerY current cursor position to decide where to mount newElem
 * @param{Array} parentPositions  list of parent positions
 * @param{Number} parentIdx  set if a child is to be mounted, null in other cases
 * @param{Array} childPositions list of child position of stele[parentIdx]
 * @param{Number} childIdx N/A here
 * @param{Boolean} addTemporary if true take precaution that this mount can be undone later
 * @returns{Object} object containing position where the newElem got mounted in the modified stele
 */
PART_ELEMENT_TWINSPOT.mountNew = (stele, newElem, centerY, parentPositions, parentIdx, childPositions, childIdx, addTemporary) => {
	newElem.temporary = addTemporary;
	/**@type{StelePart}*/ const s = parentIdx !== null ? stele[parentIdx] : null;
	if(s && testTwinspotEnabled(s)) {
		if(addTemporary) {
			stele[parentIdx] = Object.assign({}, s);
			stele[parentIdx].children = s.children.slice();
			for(let i = stele[parentIdx].children.length-1; i>=0; i--) {
				stele[parentIdx].children[i] = Object.assign({}, stele[parentIdx].children[i]);
			}
		}
		const posRel = (centerY-parentPositions[parentIdx].top)/(parentPositions[parentIdx].bottom-parentPositions[parentIdx].top);

		const c = s.container;
		if(c > 1) {
			const idx = mountAtPosition(stele[parentIdx].children, newElem, Math.round(posRel * (c-1)), c-1);
			return {parent: parentIdx, child: idx};
		} else {
			stele[parentIdx].children.push(newElem);
			return {parent: parentIdx, child: stele[parentIdx].children.length-1};
		}
	}
	return null;
};
PART_ELEMENT_SPEAKER.mountNew = PART_ELEMENT_TWINSPOT.mountNew;
PART_ELEMENT_VERT.mountNew = PART_ELEMENT_TWINSPOT.mountNew;

PART_ELEMENT_FASSADE_500.mountNew = (/**Array.<StelePart>*/ stele, /**StelePart*/ newRGBW, centerY, parentPositions, parentIdx, childPositions, childIdx, addTemporary) => {
	newRGBW.temporary = addTemporary;
	/**@type{StelePart}*/ const s = parentIdx !== null ? stele[parentIdx] : null;
	if(s && testFassade500Enabled(s)) {
		if(addTemporary) {
			stele[parentIdx] = Object.assign({}, s);
			stele[parentIdx].children = s.children.slice();
			for(let i = stele[parentIdx].children.length-1; i>=0; i--) {
				stele[parentIdx].children[i] = Object.assign({}, stele[parentIdx].children[i]);
			}
		}
		const posRel = (centerY-parentPositions[parentIdx].top)/(parentPositions[parentIdx].bottom-parentPositions[parentIdx].top);

		if(s.container > 2) {
			const idx = mountAtPosition(stele[parentIdx].children, newRGBW, Math.round(posRel * (s.container-1)), s.container-1);
			return {parent: parentIdx, child: idx};
		} else {
			stele[parentIdx].children.push(newRGBW);
			return {parent: parentIdx, child: stele[parentIdx].children.length-1};
		}
	}
	return null;
};

PART_ELEMENT_GOBO.mountNew = PART_ELEMENT_FASSADE_500.mountNew;

//PART_ELEMENT_FASSADE_1000.mountNew = (/**Array.<StelePart>*/ stele, /**StelePart*/ newRGBW, centerY,
// parentPosistions, parentIdx, childPositions, childIdx, addTemporary) => { // TODO F1000 return null; };

function aufnahmeEnabled(/**StelePartCfg*/ownPartCfg, /**Array.<StelePart>*/stele, /**Number*/ currentHeight) {
	let count=1;
	let count1500 = (ownPartCfg === PART_MODUL_AUFNAHME_1500 ? 1 : 0);
	for(let i=stele.length-1; i>=0; i--) {
		switch(stele[i].name) {
			case PART_MODUL_AUFNAHME_1500_NAME:
				count1500++;
				// falls through
			case PART_MODUL_AUFNAHME_250_NAME:
			case PART_MODUL_AUFNAHME_500_NAME:
			case PART_MODUL_AUFNAHME_1000_NAME:
				count++;
				break;
			default: // make eslint happy with this useless line
		}
	}
	if(count > 6 || count1500 > 1 || currentHeight + ownPartCfg.H > 4000) {
		return false;
	}
	return true;
}

PART_MODUL_KAMERA.enabled = function(/**Array.<StelePart>*/ stele, currentHeight) {
	const oC = heightOverCam(stele);
	if(oC.idx >= 0) // nur eine Cam erlaubt
		return false;
	return (currentHeight + PART_MODUL_KAMERA.H <= 4000);
};

PART_MODUL_RGBW.enabled = function(/**Array.<StelePart>*/ stele, /**Number*/ currentHeight) {
 	if (!(currentHeight + PART_MODUL_RGBW.H <= 4000))
		return false;
	for (let i=0; i<stele.length; i++) {
		if(stele[i].name === PART_MODUL_RGBW_NAME) {
			return false;
		}
	}
	return countNecessaryDoors(stele) < 2;
};

PART_MODUL_WLAN.enabled = function(/**Array.<StelePart>*/ stele, /**Number*/ currentHeight) {
	if (!(currentHeight + PART_MODUL_WLAN.H <= 4000))
		return false;
	for (let i=0; i<stele.length; i++) {
		if(stele[i].name === PART_MODUL_WLAN_NAME) {
			return false;
		}
	}
	return true;
};

// WEGE ist immer ganz oben, daher auch dann disablen, wenn sie wegen dem Kamera-Modul gesperrt werden.
PART_MODUL_WEGE.enabled = function(/**Array.<StelePart>*/ stele, currentHeight) {
	const oC = heightOverCam(stele);
	if(oC.height + PART_MODUL_WEGE.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT)
		return false;
	return (currentHeight + PART_MODUL_WEGE.H - PART_DECKEL.H <= 4000) && // Wenn WEGE eingesetzt wird, verschwinder der in currentHeight berücksichtigte Deckel
		(stele.length === 0 || (stele[0].name !== PART_MODUL_WEGE_NAME && stele[0].name !== PART_MODUL_WEGE2_NAME));
};
PART_MODUL_WEGE2.enabled = function(/**Array.<StelePart>*/ stele, currentHeight) {
	const oC = heightOverCam(stele);
	if(oC.height + PART_MODUL_WEGE2.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT)
		return false;
	return (currentHeight + PART_MODUL_WEGE2.H - PART_DECKEL.H <= 4000) &&
		(stele.length === 0 || (stele[0].name !== PART_MODUL_WEGE_NAME && stele[0].name !== PART_MODUL_WEGE2_NAME));
};

PART_MODUL_AUFNAHME_250.enabled = aufnahmeEnabled.bind(null, PART_MODUL_AUFNAHME_250);
PART_MODUL_AUFNAHME_500.enabled = aufnahmeEnabled.bind(null, PART_MODUL_AUFNAHME_500);
PART_MODUL_AUFNAHME_1000.enabled = aufnahmeEnabled.bind(null, PART_MODUL_AUFNAHME_1000);
PART_MODUL_AUFNAHME_1500.enabled = aufnahmeEnabled.bind(null, PART_MODUL_AUFNAHME_1500);

function testTwinspotEnabled(/**StelePart*/s) {
	if(!s.container) return false;

	let used = 0;
	for(let i=s.children.length-1; i>=0; i--) {
		used += (s.children[i].name === PART_ELEMENT_FASSADE_500_NAME ||
			s.children[i].name === PART_ELEMENT_GOBO_NAME) ?
			2 : 1;
	}
	return (s.container - used >= 1);
}

PART_ELEMENT_TWINSPOT.enabled = (/**Array.<StelePart>*/ stele) => {
	for(let i = stele.length-1; i>=0; i--) {
		if(testTwinspotEnabled(stele[i])) {
			return true;
		}
	}
	return false;
};
PART_ELEMENT_VERT.enabled = PART_ELEMENT_TWINSPOT.enabled;

PART_ELEMENT_SPEAKER.enabled = (stele) => {
	let tsEnabled = false;
	for(let i = stele.length-1; i>=0; i--) {
		const s = stele[i];
		if(!s.container)
			continue;
		let used = 0;
		for(let j=s.children.length-1; j>=0; j--) {
			if(s.children[j].name === PART_ELEMENT_SPEAKER_NAME) {
				return false;
			}
			used += (s.children[j].name === PART_ELEMENT_FASSADE_500_NAME
				|| s.children[j].name === PART_ELEMENT_GOBO_NAME) ?
				2 : 1;
		}
		tsEnabled = tsEnabled || (s.container - used >= 1);
	}
	return tsEnabled;
};

function testFassade500Enabled(/**StelePart*/ s) {
	if(!s.container) return false;

	let used = 0;
	for(let i=s.children.length-1; i>=0; i--) {
		used += (s.children[i].name === PART_ELEMENT_FASSADE_500_NAME ||
			s.children[i].name === PART_ELEMENT_GOBO_NAME) ?
			2 : 1;
	}
	return (s.container - used >= 2);
}
PART_ELEMENT_FASSADE_500.enabled = (/**Array.<StelePart>*/ stele) => {
	for(let i = stele.length-1; i>=0; i--) {
		if(testFassade500Enabled(stele[i])) {
			return true;
		}
	}
	return false;
};

export function countNecessaryDoors(stele) {
	let count=0;
	for (let i = stele.length - 1; i >= 0; i--) {
		if(!stele[i].container) {
			count += stele[i].name === PART_MODUL_RGBW_NAME ?
				1 : 0;
			continue;
		}
		const s=stele[i];
		for(let j=s.children.length-1; j>=0; j--) {
			count += (s.children[j].name === PART_ELEMENT_GOBO_NAME) ?
				1 : 0;
		}
	}
	return count;
}

PART_ELEMENT_GOBO.enabled = (stele) => (PART_ELEMENT_FASSADE_500.enabled(stele) && countNecessaryDoors(stele) < 2);


PART_MODUL_CHARGING.enabled = function(/**Array.<StelePart>*/ stele, currentHeight, /**SteleCharging*/ charging) {
	return (charging.count === 0);
};


//PART_ELEMENT_FASSADE_1000.enabled = (/**Array.<StelePart>*/ stele) => {
//	return false;
//};

// vier scopes, vier Arrays für: Fassade, Platz, Objekt, Weg

const scopeParts = [
  [ PART_MODUL_RGBW,
	  Object.assign({}, PART_MODUL_AUFNAHME_1000, {childs: [PART_ELEMENT_FASSADE_500, PART_ELEMENT_FASSADE_500]})
	],
	[ PART_MODUL_RGBW,
		Object.assign({}, PART_MODUL_AUFNAHME_250, {childs: [ PART_ELEMENT_VERT ]}),
	],
	[ PART_MODUL_RGBW,
		Object.assign({}, PART_MODUL_AUFNAHME_250, {childs: [ PART_ELEMENT_TWINSPOT ]}),
		Object.assign({}, PART_MODUL_AUFNAHME_1000, {childs: [ PART_ELEMENT_TWINSPOT, PART_ELEMENT_TWINSPOT, PART_ELEMENT_TWINSPOT ]})
	],
	[ PART_MODUL_WEGE,
	]
];

const scope2a250alt = Object.assign({}, PART_MODUL_AUFNAHME_250, {childs: [ PART_ELEMENT_TWINSPOT ]});
const scope2a500alt = Object.assign({}, PART_MODUL_AUFNAHME_500, {childs: [ PART_ELEMENT_TWINSPOT, PART_ELEMENT_TWINSPOT ]});

export function getScopeParts(flags) {
	const ret = scopeParts.slice();
	if(flags[0] && flags[2]) {
		ret[2] = [ PART_MODUL_RGBW,
			scope2a250alt,
			scope2a500alt
		];
	}
	return ret;
}

/**
 * calculate Option for part mounted at specific position. not used for charging station. @see option-store.js
 * @param{Array.<StelePart>} stele Array of SteleParts for which the required Options will be calculated
 * @param{Object} idxs parent and if applicable child index
 * @param{Number} currentHeight current Height of mounted parts
 * @constructor
 */
export function Options(stele, idxs, currentHeight) {
	if(!stele || !idxs || !stele[idxs.parent]) return;

	const name= stele[idxs.parent].name;
	const wege = (name === PART_MODUL_WEGE_NAME || name === PART_MODUL_WEGE2_NAME);
	this.idxs = idxs;
	this.rotation = stele[idxs.parent].container;
	this.cam = (name === PART_MODUL_KAMERA_NAME);
	this.size = (this.rotation && !this.distribution) || wege;
	if(this.size) {
		if(stele[idxs.parent].container) {
			const oC = heightOverCam(stele);
			const testCam = idxs.parent < oC.idx;
			const chopped=stele.slice();
			chopped.splice(idxs.parent, 1);
			const choppedHeight = currentHeight - stele[idxs.parent].cfg.H;
			oC.height -= stele[idxs.parent].cfg.H;
			this.sizes = [ PART_MODUL_AUFNAHME_250 ]; // passt immer, weil das bestehende ja mindestens ein 250er ist

			if( !(testCam && oC.height + PART_MODUL_AUFNAHME_500.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT) &&
				PART_MODUL_AUFNAHME_500.enabled(chopped, choppedHeight)
			) {
				this.sizes.push(PART_MODUL_AUFNAHME_500);
				if( !(testCam && oC.height + PART_MODUL_AUFNAHME_1000.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT) &&
					PART_MODUL_AUFNAHME_1000.enabled(chopped, choppedHeight)
				) {
					this.sizes.push(PART_MODUL_AUFNAHME_1000);
					if( !(testCam && oC.height + PART_MODUL_AUFNAHME_1000.H > PART_MODUL_KAMERA_MAX_SUPERHEIGHT) &&
						PART_MODUL_AUFNAHME_1500.enabled(chopped, choppedHeight)
					) {
						this.sizes.push(PART_MODUL_AUFNAHME_1500);
					}
				}
			}
		} else if(wege) {
			// PART_MODUL_WEGE.enabled testen selbst auf Kamera
			const chopped=stele.slice();
			chopped.splice(idxs.parent, 1);
			const choppedHeight = currentHeight - stele[idxs.parent].cfg.H + PART_DECKEL.H; // we chopped a WEGE-Modul so now there's a DECKEL needed
			if(PART_MODUL_WEGE.enabled(chopped, choppedHeight))
				this.sizes = [PART_MODUL_WEGE2, PART_MODUL_WEGE];
			else
				this.sizes = [PART_MODUL_WEGE2];
			this.paramWege = true;
		} else { // RGBW, else-ohne-if gilt nur solange es keine f1000 gibt
		}
	}
	// weitere Optionen für Lichtparameter

	// FIXME GOBO
	if(idxs.child !== null && idxs.child >= 0) {
		const childName = stele[idxs.parent].children[idxs.child].name;
		this.paramFassade = (childName === PART_ELEMENT_FASSADE_500_NAME); // TODO F1000
		this.paramSpot = (childName === PART_ELEMENT_TWINSPOT_NAME);
		this.paramGobo = (childName === PART_ELEMENT_GOBO_NAME);
		this.paramVert = (childName === PART_ELEMENT_VERT_NAME);
		//this.childType = stele[idxs.parent].children[idxs.child].type;
		this.childVert = stele[idxs.parent].children[idxs.child].vert; // equals undefined if not fassade
	}
	this.distribution = wege || this.paramFassade || this.paramSpot || this.paramGobo || this.paramVert;
}



export const ALL_PARTS = {};
// IMPORTANT: keep this list in sync with the list of defined names and configs at the beginning of the file

ALL_PARTS[PART_MODUL_WLAN_NAME] = PART_MODUL_WLAN;
ALL_PARTS[PART_MODUL_KAMERA_NAME] = PART_MODUL_KAMERA;
ALL_PARTS[PART_MODUL_RGBW_NAME] = PART_MODUL_RGBW;
ALL_PARTS[PART_MODUL_WEGE_NAME] = PART_MODUL_WEGE;
ALL_PARTS[PART_MODUL_WEGE2_NAME] = PART_MODUL_WEGE2;
ALL_PARTS[PART_MODUL_AUFNAHME_250_NAME] = PART_MODUL_AUFNAHME_250;
ALL_PARTS[PART_MODUL_AUFNAHME_500_NAME] = PART_MODUL_AUFNAHME_500;
ALL_PARTS[PART_MODUL_AUFNAHME_1000_NAME] = PART_MODUL_AUFNAHME_1000;
ALL_PARTS[PART_MODUL_AUFNAHME_1500_NAME] = PART_MODUL_AUFNAHME_1500;
ALL_PARTS[PART_ELEMENT_SPEAKER_NAME] = PART_ELEMENT_SPEAKER;
ALL_PARTS[PART_ELEMENT_VERT_NAME] = PART_ELEMENT_VERT;
ALL_PARTS[PART_ELEMENT_TWINSPOT_NAME] = PART_ELEMENT_TWINSPOT;
ALL_PARTS[PART_ELEMENT_GOBO_NAME] = PART_ELEMENT_GOBO;
ALL_PARTS[PART_ELEMENT_FASSADE_500_NAME] = PART_ELEMENT_FASSADE_500;
//ALL_PARTS[PART_ELEMENT_FASSADE_1000_NAME] = PART_ELEMENT_FASSADE_1000;

ALL_PARTS[PART_MODUL_CHARGING_NAME] = PART_MODUL_CHARGING;

// names only used by zoom, summary and datasheet
ALL_PARTS[PART_DECKEL_NAME] = PART_DECKEL;
ALL_PARTS[PART_BASIS_NAME] = PART_BASIS;

// not defined parts as they are only used by zoom
//ALL_PARTS[PART_BASIS_TOP_NAME] = PART_BASIS_TOP;
//ALL_PARTS[PART_MODUL_RGBW_TOP_NAME] = PART_MODUL_RGBW_TOP;
//ALL_PARTS[PART_MODUL_RGBW_W_TOP_NAME] = PART_MODUL_RGBW_W_TOP;
//ALL_PARTS[PART_MODUL_AUFNAHME_250_COVER_NAME] = PART_MODUL_AUFNAHME_250_COVER;
//ALL_PARTS[PART_MODUL_AUFNAHME_500_COVER_NAME] = PART_MODUL_AUFNAHME_500_COVER;
//ALL_PARTS[PART_MODUL_AUFNAHME_1000_COVER_NAME] = PART_MODUL_AUFNAHME_1000_COVER;
//ALL_PARTS[PART_MODUL_AUFNAHME_1500_COVER_NAME] = PART_MODUL_AUFNAHME_1500_COVER;

// names only used be summary and datasheet
ALL_PARTS[PART_LEITUNG_NAME] = PART_LEITUNG;
ALL_PARTS[PART_KASTEN_NAME] = PART_KASTEN;


export const PARTS_NEEDING_A_CABLE = [PART_ELEMENT_FASSADE_500_NAME, PART_ELEMENT_TWINSPOT_NAME, PART_MODUL_WEGE_NAME, PART_MODUL_WEGE2_NAME, PART_ELEMENT_VERT_NAME]; // Gobo kein Kabel // FIXME Kabel für Vert-element?
